import { useRef, useState } from "react";

import styled from "styled-components";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardRibbon,
    ChevronUpIcon,
    Flex,
    LinkExternal,
    Heading,
    Image,
    TimerIcon,
    Text,
    TokenPairImage,
    // Box,
} from "@pancakeswap/uikit";
import BigNumber from "bignumber.js";
import { BIG_ZERO } from "utils/bigNumber";
import Balance from "components/Balance";

import headerimage from "../../../../assets/images/headerimage.png";
// import AprRow from "../PoolCard/AprRow";
// import Stake from '../PoolsTable/ActionPanel/Stake'
// import AutoEarningsCell from "../PoolsTable/Cells/AutoEarningsCell";
// import AutoHarvestAction from "../PoolsTable/ActionPanel/AutoHarvest";
import drivenx from "../../../../assets/images/drivenx.png";
import bnb from "../../../../assets/images/bnb.png";
import { Avatar, Box, Link } from '@mui/material';
import linkforward from "../../../../assets/images/linkforward.svg";
import clock from "../../../../assets/images/clock.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FarmFooter from "./FarmFooter";
import LiquidityModal from "views/Pools/components/Modal/LiquidityModal";
import FarmNameCell from "../FarmsTable/Cells/FarmNameCell";
import AprRow from "./AprRow";
import FarmStake from "../FarmsTable/FarmActionPanel/FarmStake";
import FarmAutoHarvest from "../FarmsTable/FarmActionPanel/FarmAutoHarvest";


export interface DeserializedPool {
    totalStaked?: BigNumber;
    stakingLimit?: BigNumber;
    stakingLimitEndBlock?: number;
    profileRequirement?: {
        required: boolean;
        thresholdPoints: BigNumber;
    };
    userData?: {
        allowance: BigNumber;
        stakingTokenBalance: BigNumber;
        stakedBalance: BigNumber;
        pendingReward: BigNumber;
    };
}

const StyledTable = styled.div`
  border-radius: ${({ theme }) => theme.radii.card};
  scroll-margin-top: 64px;

  background-color: ${({ theme }) => theme.card.background};
  > div:not(:last-child) {
    border-bottom: 2px solid ${({ theme }) => theme.colors.disabled};
  }
`;

const StyledTableBorder = styled.div`
  background-color: ${({ theme }) => theme.colors.cardBorder};
  padding: 1px 1px 3px 1px;
  background-size: 400% 400%;
`;

export const StyledCard = styled(Card) <{ isFinished?: boolean }>`
  max-width: 352px;
  margin: 0 8px 24px;
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  background-color : #00FED9;
  padding : 1px;
  align-self: baseline;
  position: relative;
  color: ${({ isFinished, theme }) =>
        theme.colors[isFinished ? "textDisabled" : "secondary"]};

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 46px;
  }
`;

const Wrapper = styled(CardHeader)`
  border-radius: ${({ theme }) =>
        `${theme.radii.card} ${theme.radii.card} 0 0`};
  display: flex;
  justify-content: space-between;
  background : #00202F;
  max-height : 105px;

`;

const PCardBody = styled(CardBody)`
  background : #1A3342;

`;

const PLinkExternal = styled(LinkExternal)`
  text-decoration : none;
`

const MainImage = styled.div`
  position: absolute;
  width: 92%;
  inset: 0px auto auto 0px;
  z-index: 5;
`;

const LockDuration = styled(Box)`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
`;

const Earned = styled.div`
  font-weight: 600;
  font-size: 12px;
  padding-top: 10px;
  display: flex;
  /* justify-content: space-around; */
  text-transform: uppercase;
`;

export const ActionContent = styled.div`
  /* padding: 16px; */
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  margin-bottom: 16px;
`;
export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
`;

const Compound = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
`;
const Buttons = styled(Box)`
  display: flex;
  flex-direction: column;
`;
const HarvestButton = styled(Button)`
  background-color: rgb(233, 234, 235);
  border-color: rgb(233, 234, 235);
  box-shadow: none;
  color: rgb(189, 194, 196);
  cursor: not-allowed;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  margin-bottom: 4px;
  height: auto;
  padding: 5px 10px;
  font-size: 12px;
`;
const GetButton = styled(Button)`
  align-items: center;
  border: 0px none;
  border-radius: 16px;
  box-shadow: rgba(14, 14, 44, 0.4) 0px -1px 0px 0px inset;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -moz-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: currentcolor none 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  background-color: #00FED9;
  color: black;
  margin-bottom: 10px;
  height: auto;
  font-size: 11px;
  padding: 5px 10px;

`

const CompoundButtoon = styled(Button)`
  background-color: rgb(233, 234, 235);
  border-color: rgb(233, 234, 235);
  box-shadow: none;
  color: rgb(189, 194, 196);
  cursor: not-allowed;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  margin-bottom: 4px;
  height: auto;
  padding: 5px 10px;
  font-size: 12px;
`;

const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  background-color: rgb(15, 33, 49);
  color: white;
  width: 100%;
`;
const Cardfooterfontsz = styled(Box)`
  font-size: 14px;
`;
const FarmCard: React.FC<{ pool?: any; account: string, index?: any }> = ({
    pool,
    index,
    account,
}) => {

    const { sousId, stakingToken, earningToken, isFinished, userData } = pool;
    const stakedBalance = userData?.stakedBalance
        ? new BigNumber(userData.stakedBalance)
        : BIG_ZERO;
    const accountHasStakedBalance = stakedBalance.gt(0);
    const [isExpanded, setIsExpanded] = useState(false)
    const [open, setOpen] = useState(false);

    const liquidty = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <StyledCard>
            
            <Wrapper>
                {/* <Flex alignItems="center" justifyContent="space-between">
                    123
                </Flex> */}
                <Flex flexDirection="column">
                    <Text fontSize="24px" bold color="#00FED9" marginBottom={"0px"}>
                        Earn DVX
                    </Text>
                    <Text fontSize="16px" color="#B1B3CB">
                        Stake DVX-WBNB
                    </Text>
                </Flex>
                <Box sx={{ position: 'relative', ml: 2 }}>
                    <Box sx={{ position: 'relative', zIndex: '6', maxHeight: '60px', maxWidth: '60px' }}>
                        <Avatar sx={{ width: "60px", height: "60px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
                    </Box>
                    <Box sx={{ position: 'relative', inset: '-60px auto auto -15px', zIndex: '5', maxHeight: '30px', maxWidth: '30px' }}>
                        <img style={{ width: "30px", height: "30px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={bnb} alt="bnb" />
                    </Box>
                </Box>
            </Wrapper>
            <PCardBody>
                <AprRow pool={pool} index={index} stakedBalance={stakedBalance} />
                <Flex mt="24px" flexDirection="column">
                    <FarmStake pool={pool} />
                    <FarmAutoHarvest pool={pool} />
                </Flex>
            </PCardBody>
            <FarmFooter pool={pool} account={account} setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
            {isExpanded && (
                <>
                    <Box sx={{ background: '#1A3342' }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", px: 3, pr: 3, color: "#B1B3CB" }}>
                            <Cardfooterfontsz>
                                Liquidity:
                            </Cardfooterfontsz>
                            <Cardfooterfontsz sx={{ color: 'white' }}>
                                {pool.liquidity.toFixed(5)}
                            </Cardfooterfontsz>
                        </Box>
                        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'end', mr: 2 }}>
                            <GetButton scale={'sm'} style={{ alignItems: 'center', border: '0px none', borderRadius: '16px' }} onClick={() => liquidty()} disabled>
                                Get {pool.token0Symbol} - {pool.token1Symbol}
                            </GetButton>
                        </Box>
                        <Flex mb="2px" justifyContent={['flex-end', 'flex-end', 'flex-end']} mr="3" pt="4px">
                            <PLinkExternal href={'https://bscscan.com/token/0x6db3972c6a5535708e7a4f7ad52f24d178d9a93e'} bold={false} color='#00FED9'>
                                <Text fontSize="14px" color='white' >
                                    See Token Info
                                </Text>
                            </PLinkExternal>
                        </Flex>
                        <Flex pb="20px" justifyContent={['flex-end', 'flex-end', 'flex-end']} mr="3" pt="4px">
                            <PLinkExternal href={'https://www.drivenecosystem.com/'} color='#00FED9'>
                                <Text fontSize="14px" color='white' >
                                    View Project Site
                                </Text>
                            </PLinkExternal>
                        </Flex>
                    </Box>
                </>
            )}
            <LiquidityModal open={open} onClose={handleClose} pool={pool} ></LiquidityModal>
        </StyledCard>
    );
};

export default FarmCard;
